import React from 'react'
import { AppRetailerBlockContainer } from "@components/DataBlocks"


export default function sitesNameColumn() {

	return [{
		name: 'sitesNameFilter',
		label: 'Sites',
		options: {
			display: 'excluded',
			filterType: 'textField'
		}
	},
		{
			name: 'sitesName',
			label: 'Site',
			options: {
				filter: false,
				headerAlign: "left",
				customBodyRowRenderLite: value => <AppRetailerBlockContainer rows={value}/>,
			}
		}]
}